/**
 * 图表组件
 * @description 图表组件
 * @author mll 
 * @date 2020-2-11
 */
import React from 'react';
import { connect } from 'dva';
import { component_tool, framework_tool } from '../../../tool'
let { WizContainer } = framework_tool;
let { WizG2Plot, WizCard } = component_tool

class Charts extends WizContainer {

    componentName = 'Charts';

    state = {
    };

    _componentDidMount() {
        this._ringDiagram()
        this._pie()
        this._line()
        this._groupBar()
        this._percentageStackColumn()
        this._area()
        this._radar()
    }

    _render() {
        return [
            <WizCard title={'环图'} icon='0'>
                <div id='ringDiagram'></div>
            </WizCard>,
            <WizCard title={'饼图'} icon='0'>
                <div id='pie'></div>
            </WizCard>,
            <WizCard title={'折线图'} icon='0'>
                <div id='line'></div>
            </WizCard>,
            <WizCard title={'条形图'} icon='0'>
                <div id='groupBar'></div>
            </WizCard>,
            <WizCard title={'柱状图'} icon='0'>
                <div id='percentageStackColumn'></div>
            </WizCard>,
            <WizCard title={'面积图'} icon='0'>
                <div id='area'></div>
            </WizCard>,
            <WizCard title={'雷达图'} icon='0'>
                <div id='radar'></div>
            </WizCard>
        ]

    }

    /**
     * 环图demo
     */
    _ringDiagram() {
        const container = document.getElementById('ringDiagram');
        const data = [
            {
                "x": "分类一",
                "y": 754,
                "serie": "default"
            },
            {
                "x": "分类二",
                "y": 477,
                "serie": "default"
            },
            {
                "x": "分类三",
                "y": 468,
                "serie": "default"
            },
            {
                "x": "分类四",
                "y": 385,
                "serie": "default"
            },
            {
                "x": "分类五",
                "y": 349,
                "serie": "default"
            }
        ];
        const config = {
            "title": {
                "visible": true,
                "text": "环图"
            },
            "description": {
                "visible": true,
                "text": "一个简单的环图"
            },
            "legend": {
                "position": "right-top",
                "flipPage": false
            },
            "width": 560,
            "height": 376,
            "forceFit": false,
            "radius": 1,
            "innerRadius": 0.5,
            "statistic": {
                "visible": false
            },
            "colorField": "x",
            "angleField": "y"
        }
        const plot = new WizG2Plot.Ring(container, {
            data,
            ...config,
        });
        plot.render();
    }

    /**
     * 饼图
     */
    _pie() {
        const container = document.getElementById('pie');
        const data = [
            {
                "x": "分类一",
                "y": 888,
                "serie": "default"
            },
            {
                "x": "分类二",
                "y": 477,
                "serie": "default"
            },
            {
                "x": "分类三",
                "y": 468,
                "serie": "default"
            },
            {
                "x": "分类四",
                "y": 385,
                "serie": "default"
            },
            {
                "x": "分类五",
                "y": 349,
                "serie": "default"
            }
        ];
        const config = {
            "title": {
                "visible": true,
                "text": "饼图"
            },
            "description": {
                "visible": true,
                "text": "一个简单的饼图"
            },
            "legend": {
                "flipPage": false
            },
            "width": 560,
            "height": 376,
            "forceFit": false,
            "radius": 1,
            "colorField": "x",
            "angleField": "y"
        }
        const plot = new WizG2Plot.Pie(container, {
            data,
            ...config,
        });
        plot.render();
    }

    /**
     * 折线图
     */
    _line() {
        const container = document.getElementById('line');
        const data = [
            {
                "x": "2019-03",
                "y": 385,
                "serie": "Paris"
            },
            {
                "x": "2019-04",
                "y": 888,
                "serie": "Paris"
            },
            {
                "x": "2019-05",
                "y": 164,
                "serie": "Paris"
            },
            {
                "x": "2019-06",
                "y": 468,
                "serie": "Paris"
            },
            {
                "x": "2019-07",
                "y": 477,
                "serie": "Paris"
            },
            {
                "x": "2019-03",
                "y": 291,
                "serie": "London"
            },
            {
                "x": "2019-04",
                "y": 484,
                "serie": "London"
            },
            {
                "x": "2019-05",
                "y": 293,
                "serie": "London"
            },
            {
                "x": "2019-06",
                "y": 147,
                "serie": "London"
            },
            {
                "x": "2019-07",
                "y": 618,
                "serie": "London"
            }
        ];
        const config = {
            "title": {
                "visible": true,
                "text": "折线图"
            },
            "description": {
                "visible": true,
                "text": "一个简单的折线图"
            },
            "legend": {
                "flipPage": false
            },
            "forceFit": false,
            "width": 560,
            "height": 376,
            "xField": "x",
            "yField": "y",
            "seriesField": "serie"
        }
        const plot = new WizG2Plot.Line(container, {
            data,
            ...config,
        });
        plot.render();
    }

    /**
     * 条形图
     */
    _groupBar() {
        const container = document.getElementById('groupBar');
        const data = [
            {
                "x": "2019-03",
                "y": 385,
                "serie": "Paris"
            },
            {
                "x": "2019-04",
                "y": 578,
                "serie": "Paris"
            },
            {
                "x": "2019-05",
                "y": 349,
                "serie": "Paris"
            },
            {
                "x": "2019-06",
                "y": 468,
                "serie": "Paris"
            },
            {
                "x": "2019-07",
                "y": 477,
                "serie": "Paris"
            },
            {
                "x": "2019-03",
                "y": 291,
                "serie": "London"
            },
            {
                "x": "2019-04",
                "y": 484,
                "serie": "London"
            },
            {
                "x": "2019-05",
                "y": 293,
                "serie": "London"
            },
            {
                "x": "2019-06",
                "y": 147,
                "serie": "London"
            },
            {
                "x": "2019-07",
                "y": 618,
                "serie": "London"
            }
        ];
        const config = {
            "title": {
                "visible": true,
                "text": "分组条形图"
            },
            "description": {
                "visible": true,
                "text": "一个基础的分组条形图"
            },
            "legend": {
                "flipPage": false
            },
            "xAxis": {
                "title": {
                    "text": "数值"
                }
            },
            "yAxis": {
                "title": {
                    "text": "日期"
                }
            },
            "forceFit": false,
            "width": 560,
            "height": 376,
            "xField": "y",
            "yField": "x",
            "groupField": "serie"
        }
        const plot = new WizG2Plot.GroupBar(container, {
            data,
            ...config,
        });
        plot.render();
    }

    /**
     * 柱状图
     */
    _percentageStackColumn() {
        const container = document.getElementById('percentageStackColumn');
        const data = [
            {
                "x": "2019-03",
                "y": 385,
                "serie": "Paris"
            },
            {
                "x": "2019-04",
                "y": 888,
                "serie": "Paris"
            },
            {
                "x": "2019-05",
                "y": 349,
                "serie": "Paris"
            },
            {
                "x": "2019-06",
                "y": 468,
                "serie": "Paris"
            },
            {
                "x": "2019-07",
                "y": 477,
                "serie": "Paris"
            },
            {
                "x": "2019-03",
                "y": 291,
                "serie": "London"
            },
            {
                "x": "2019-04",
                "y": 484,
                "serie": "London"
            },
            {
                "x": "2019-05",
                "y": 293,
                "serie": "London"
            },
            {
                "x": "2019-06",
                "y": 147,
                "serie": "London"
            },
            {
                "x": "2019-07",
                "y": 618,
                "serie": "London"
            }
        ];
        const config = {
            "title": {
                "visible": true,
                "text": "百分比堆叠柱状图"
            },
            "description": {
                "visible": true,
                "text": "一个简单的百分比堆叠柱状图"
            },
            "legend": {
                "flipPage": false
            },
            "xAxis": {
                "title": {
                    "text": "日期"
                }
            },
            "yAxis": {
                "title": {
                    "text": "百分比"
                }
            },
            "forceFit": false,
            "width": 560,
            "height": 376,
            "xField": "x",
            "yField": "y",
            "stackField": "serie"
        }
        const plot = new WizG2Plot.PercentageStackColumn(container, {
            data,
            ...config,
        });
        plot.render();
    }

    /**
     * 面积图
     */
    _area() {
        const container = document.getElementById('area');
        const data = [
            {
                "x": "2019-03",
                "y": 385,
                "serie": "Paris"
            },
            {
                "x": "2019-04",
                "y": 888,
                "serie": "Paris"
            },
            {
                "x": "2019-05",
                "y": 349,
                "serie": "Paris"
            },
            {
                "x": "2019-06",
                "y": 468,
                "serie": "Paris"
            },
            {
                "x": "2019-07",
                "y": 477,
                "serie": "Paris"
            },
            {
                "x": "2019-03",
                "y": 291,
                "serie": "London"
            },
            {
                "x": "2019-04",
                "y": 484,
                "serie": "London"
            },
            {
                "x": "2019-05",
                "y": 293,
                "serie": "London"
            },
            {
                "x": "2019-06",
                "y": 147,
                "serie": "London"
            },
            {
                "x": "2019-07",
                "y": 618,
                "serie": "London"
            }
        ];
        const config = {
            "title": {
                "visible": true,
                "text": "面积图"
            },
            "description": {
                "visible": true,
                "text": "一个简单的面积图"
            },
            "legend": {
                "flipPage": false
            },
            "xAxis": {
                "title": {
                    "text": "日期"
                }
            },
            "yAxis": {
                "title": {
                    "text": "数值"
                }
            },
            "forceFit": false,
            "width": 560,
            "height": 376,
            "xField": "x",
            "yField": "y",
            "seriesField": "serie"
        }
        const plot = new WizG2Plot.Area(container, {
            data,
            ...config,
        });
        plot.render();
    }

    /**
     * 雷达图
     */
    _radar() {
        const container = document.getElementById('radar');
        const data = [
            {
                "x": "防御",
                "y": 400,
                "serie": "马可波罗"
            },
            {
                "x": "速度",
                "y": 800,
                "serie": "马可波罗"
            },
            {
                "x": "攻击",
                "y": 900,
                "serie": "马可波罗"
            },
            {
                "x": "躲闪",
                "y": 250,
                "serie": "马可波罗"
            },
            {
                "x": "穿透",
                "y": 400,
                "serie": "马可波罗"
            },
            {
                "x": "防御",
                "y": 350,
                "serie": "孙尚香"
            },
            {
                "x": "速度",
                "y": 850,
                "serie": "孙尚香"
            },
            {
                "x": "攻击",
                "y": 900,
                "serie": "孙尚香"
            },
            {
                "x": "躲闪",
                "y": 100,
                "serie": "孙尚香"
            },
            {
                "x": "穿透",
                "y": 550,
                "serie": "孙尚香"
            }
        ];
        const config = {
            "title": {
                "visible": true,
                "text": "雷达图"
            },
            "description": {
                "visible": true,
                "text": "一个简单的雷达图"
            },
            "legend": {
                "flipPage": false
            },
            "width": 560,
            "height": 376,
            "forceFit": false,
            "radius": 1,
            "angleField": "x",
            "radiusField": "y",
            "seriesField": "serie"
        }
        const plot = new WizG2Plot.Radar(container, {
            data,
            ...config,
        });
        plot.render();
    }
}

const mapStateToProps = (state, ownProps) => {
    return {

    };
};

export default connect(mapStateToProps)(Charts);
